// extracted by mini-css-extract-plugin
module.exports = {"container":"e__G","readReviewButton":"e_0G","arrowRight":"e_1G","imageContainer":"e_2G","image":"e_3G","badge":"e_4G","badgeImage":"e_5G","content":"e_6G","title":"e_7G"};